import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { AddNumbersStore } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/store/addNumbersStore'

const AddNumbersContext = createContext<AddNumbersStore | null>(null)

export const useAddNumbersContext = () => {
  const context = useContext(AddNumbersContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AddNumbersProvider')

  return context
}

export const AddNumbersProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const inboxLayerStore = useInboxLayerContext()
  const store = useMemo(
    () => new AddNumbersStore(inboxLayerStore, entities),
    [inboxLayerStore, entities]
  )

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [store])

  return <AddNumbersContext.Provider value={store}>{children}</AddNumbersContext.Provider>
}
